import { addDays, startOfWeek, todayStr, ymd } from "@/lib/dates";
import { Input } from "@/components/ui/input";

export const RANGE_PRESETS = [
  { key: "today", label: "Today", range: () => [todayStr(), todayStr()] },
  { key: "week", label: "This week", range: () => [ymd(startOfWeek(new Date())), todayStr()] },
  { key: "month", label: "This month", range: () => { const d = new Date(); return [ymd(new Date(d.getFullYear(), d.getMonth(), 1)), todayStr()]; } },
  { key: "30d", label: "Last 30 days", range: () => [ymd(addDays(new Date(), -29)), todayStr()] },
];

/** Preset chips + From/To date inputs. `value` = {preset, start, end}. */
export default function DateRangeBar({ value, onChange, prefix }) {
  const { preset, start, end } = value;
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="flex flex-wrap gap-2">
        {RANGE_PRESETS.map((p) => {
          const [s, e] = p.range();
          return (
            <button key={p.key} data-testid={`${prefix}-preset-${p.key}`} data-active={preset === p.key} className="chip"
              onClick={() => onChange({ preset: p.key, start: s, end: e })}>
              {p.label}
            </button>
          );
        })}
      </div>
      <div className="grid w-full grid-cols-2 gap-2 sm:w-auto">
        <label className="min-w-0 text-xs text-slate-500">From
          <Input data-testid={`${prefix}-start-date`} type="date" value={start} max={end} className="mt-1 h-10 w-full min-w-0 px-2 text-sm"
            onChange={(e) => onChange({ preset: "", start: e.target.value, end })} />
        </label>
        <label className="min-w-0 text-xs text-slate-500">To
          <Input data-testid={`${prefix}-end-date`} type="date" value={end} min={start} className="mt-1 h-10 w-full min-w-0 px-2 text-sm"
            onChange={(e) => onChange({ preset: "", start, end: e.target.value })} />
        </label>
      </div>
      {!(start && end && start <= end) && (
        <div className="w-full text-xs text-rose-600" data-testid={`${prefix}-range-error`}>Pick a start date on or before the end date.</div>
      )}
    </div>
  );
}

export const todayRange = () => ({ preset: "today", start: todayStr(), end: todayStr() });
